import {TFunction} from 'i18next';
import {constructFilter} from './constructFilter';
import {MeetingRoom} from '../../../../../../submodules/map/types/BuildingModel';

export const SECTION_ID_SEATS = 'SECTION_ID_SEATS';

export const constructSeatFilter = (t: TFunction) => {
  const tCustom = (rangeOfSeats: string) => t('meeting:SeatFilterLabel', {rangeOfSeats});

  return constructFilter({
    sectionId: SECTION_ID_SEATS,
    sectionTitle: t('Seats'),
    type: 'or',
    data: [
      {id: '1-2' as const, label: tCustom('1-2'), value: [1, 2]},
      {id: '3-4' as const, label: tCustom('3-4'), value: [3, 4]},
      {id: '5-6' as const, label: tCustom('5-6'), value: [5, 6]},
      {id: '7-12' as const, label: tCustom('7-12'), value: [7, 12]},
      {id: '13-20' as const, label: tCustom('13-20'), value: [13, 20]},
      {id: '21+' as const, label: tCustom('21+'), value: [21, 999]},
    ],
    defaultFilterOptions: [],
    predicate: ({value: [minCapacity, maxCapacity]}, room: MeetingRoom) =>
      room.capacity >= minCapacity && room.capacity <= maxCapacity,
  });
};
